export const dashboardTranslations = {
  en: {
    generateReport: "Generate AI Report",
    askCommunity: "Ask Expert Community",
    accessLibrary: "Access Medical Library",
    soapNoteSaved: "Record your consultation",
    analysisReady: "AI Analysis Ready",
    userManagement: {
      title: "User Management",
      searchPlaceholder: "Search by name, email, or ID...",
      totalUsers: "Total Users",
      admins: "Admins",
      specialists: "Specialists",
      clients: "Clients",
      enterprise: "Enterprise",
      filters: {
        all: "All",
        admin: "Admins",
        specialist: "Specialists",
        client: "Clients",
        enterprise: "Enterprise",
      },
      sort: {
        label: "Sort by:",
        name: "Name",
        email: "Email",
        role: "Role",
        loginCount: "Logins",
        lastLogin: "Last Login",
        createdAt: "Created",
      },
      view: {
        grid: "Switch to list view",
        list: "Switch to grid view",
      },
      refresh: "Refresh",
      showing: "Showing {{count}} of {{total}} users",
      noUsers: {
        title: "No users found",
        description: "Try adjusting your search or filters",
      },
      loading: "Loading users...",
      error: "Failed to load users",
      tryAgain: "Try Again",
      userCard: {
        verified: "Verified",
        pending: "Pending",
        lastLogin: "Last login",
        logins: "Logins",
        view: "View",
        editRole: "Edit role",
        deleteUser: "Delete user",
        deleteConfirm: "Are you sure you want to delete {{name}}? This action cannot be undone.",
      },
      roles: {
        admin: "Administrator",
        specialist: "Specialist",
        client: "Client",
      },
      plans: {
        explorer: "Explorer",
        expert: "Expert",
        enterprise: "Enterprise",
      },
    },
    userDetail: {
      overview: "Overview",
      activityTab: "Activity",
      loginHistory: "Login History",
      subscriptionTab: "Subscription",
      quickStats: {
        totalLogins: "Total Logins",
        lastLogin: "Last Login",
        email: "Email",
        role: "Role",
      },
      profile: {
        title: "Profile Information",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone",
        userId: "User ID",
        accountCreated: "Account Created",
        lastUpdated: "Last Updated",
        specialty: "Specialty",
        group: "Group",
        notProvided: "Not provided",
        notSpecified: "Not specified",
        none: "None",
      },
      extendedProfile: {
        title: "Extended Profile",
        biography: "Biography",
        yearsExp: "Years of Experience",
        languages: "Languages",
        education: "Education",
        years: "{{count}} years",
      },
      activity: {
        noData: {
          title: "No activity data",
          description: "This user hasn't generated any activity yet.",
        },
        aiChat: {
          title: "AI Chat",
          conversations: "Conversations",
          messages: "Messages",
          avgMessagesPerConv: "Avg Messages/Conv",
          characters: "Characters",
        },
        soapvett: {
          title: "SOAPvett",
          recordings: "Recordings",
          sessions: "Sessions",
          avgDuration: "Avg Duration",
        },
        clinicFlow: {
          title: "ClinicFlow",
          totalAnalyses: "Total Analyses",
          normalMode: "Normal Mode",
          advancedMode: "Advanced Mode",
        },
        vettbox: {
          title: "VettBox",
          files: "Files",
          totalSize: "Total Size",
          inGB: "In GB",
        },
        phoneCalls: {
          title: "Phone Calls",
          totalCalls: "Total Calls",
          totalDuration: "Total Duration",
        },
        timeSaved: {
          title: "Time Saved",
          minutes: "Minutes",
          hours: "Hours",
          days: "Days",
        },
      },
      login: {
        recentSessions: "Recent Login Sessions",
        currentSession: "Current Session",
        loginNumber: "Login #{{number}}",
        noHistory: "No login history available",
        never: "Never",
        notAvailable: "Not available",
        relativeTime: {
          justNow: "Just now",
          minutesAgo: "{{count}}m ago",
          hoursAgo: "{{count}}h ago",
          daysAgo: "{{count}}d ago",
          weeksAgo: "{{count}}w ago",
        },
      },
      subscription: {
        title: "Subscription Details",
        plan: "Plan",
        status: "Status",
        paymentStatus: "Payment Status",
        amount: "Amount",
        startDate: "Start Date",
        endDate: "End Date",
        created: "Created",
        lastUpdated: "Last Updated",
        unknown: "Unknown",
        features: {
          entUnlimited: "Unlimited consultations",
          entExpert: "All expert features",
          entCorporate: "Corporate tools access",
          entSupport: "Priority enterprise support",
          entIndefinite: "Indefinite access",
          expUnlimited: "Unlimited consultations",
          expAll: "All features",
          expSupport: "Priority support",
          exBasic: "Basic features",
          exLimited: "Limited consultations",
          exStandard: "Standard support",
        },
        noSubscription: {
          title: "No subscription",
          description: "This user doesn't have an active subscription.",
        },
      },
      actions: {
        editRole: "Edit Role",
        editProfile: "Edit Profile",
        editBio: "Edit Bio",
        deactivate: "Deactivate",
        activate: "Activate",
        refresh: "Refresh",
        deleteUser: "Delete User",
        deactivateConfirm: "Deactivate {{name}}? They will not be visible to clients.",
        activateConfirm: "Activate {{name}}? They will be visible to clients.",
        deleteError: "Error deleting user: {{error}}",
        toggleError: "Error: {{error}}",
      },
      status: {
        active: "Active",
        inactive: "Inactive",
        verified: "Verified",
        pending: "Pending",
      },
    },
    pagination: {
      previous: "Previous",
      next: "Next",
    },
  },
  es: {
    generateReport: "Generar Informe IA",
    askCommunity: "Preguntar a Expertos",
    accessLibrary: "Acceder a Biblioteca",
    soapNoteSaved: "Graba tu consulta",
    analysisReady: "Análisis IA Listo",
    userManagement: {
      title: "Gestión de Usuarios",
      searchPlaceholder: "Buscar por nombre, email o ID...",
      totalUsers: "Total de Usuarios",
      admins: "Administradores",
      specialists: "Especialistas",
      clients: "Clientes",
      enterprise: "Enterprise",
      filters: {
        all: "Todos",
        admin: "Administradores",
        specialist: "Especialistas",
        client: "Clientes",
        enterprise: "Enterprise",
      },
      sort: {
        label: "Ordenar por:",
        name: "Nombre",
        email: "Email",
        role: "Rol",
        loginCount: "Inicios de sesión",
        lastLogin: "Último acceso",
        createdAt: "Creado",
      },
      view: {
        grid: "Cambiar a vista de lista",
        list: "Cambiar a vista de cuadrícula",
      },
      refresh: "Actualizar",
      showing: "Mostrando {{count}} de {{total}} usuarios",
      noUsers: {
        title: "No se encontraron usuarios",
        description: "Intenta ajustar tu búsqueda o filtros",
      },
      loading: "Cargando usuarios...",
      error: "Error al cargar usuarios",
      tryAgain: "Intentar de nuevo",
      userCard: {
        verified: "Verificado",
        pending: "Pendiente",
        lastLogin: "Último acceso",
        logins: "Inicios de sesión",
        view: "Ver",
        editRole: "Editar rol",
        deleteUser: "Eliminar usuario",
        deleteConfirm: "¿Estás seguro de que deseas eliminar a {{name}}? Esta acción no se puede deshacer.",
      },
      roles: {
        admin: "Administrador",
        specialist: "Especialista",
        client: "Cliente",
      },
      plans: {
        explorer: "Explorer",
        expert: "Expert",
        enterprise: "Enterprise",
      },
    },
    userDetail: {
      overview: "Resumen",
      activityTab: "Actividad",
      loginHistory: "Historial de Acceso",
      subscriptionTab: "Suscripción",
      quickStats: {
        totalLogins: "Total de Accesos",
        lastLogin: "Último Acceso",
        email: "Email",
        role: "Rol",
      },
      profile: {
        title: "Información del Perfil",
        fullName: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        userId: "ID de Usuario",
        accountCreated: "Cuenta Creada",
        lastUpdated: "Última Actualización",
        specialty: "Especialidad",
        group: "Grupo",
        notProvided: "No proporcionado",
        notSpecified: "No especificado",
        none: "Ninguno",
      },
      extendedProfile: {
        title: "Perfil Extendido",
        biography: "Biografía",
        yearsExp: "Años de Experiencia",
        languages: "Idiomas",
        education: "Educación",
        years: "{{count}} años",
      },
      activity: {
        noData: {
          title: "Sin datos de actividad",
          description: "Este usuario aún no ha generado actividad.",
        },
        aiChat: {
          title: "Chat IA",
          conversations: "Conversaciones",
          messages: "Mensajes",
          avgMessagesPerConv: "Prom Mensajes/Conv",
          characters: "Caracteres",
        },
        soapvett: {
          title: "SOAPvett",
          recordings: "Grabaciones",
          sessions: "Sesiones",
          avgDuration: "Duración Prom",
        },
        clinicFlow: {
          title: "ClinicFlow",
          totalAnalyses: "Total Análisis",
          normalMode: "Modo Normal",
          advancedMode: "Modo Avanzado",
        },
        vettbox: {
          title: "VettBox",
          files: "Archivos",
          totalSize: "Tamaño Total",
          inGB: "En GB",
        },
        phoneCalls: {
          title: "Llamadas Telefónicas",
          totalCalls: "Total de Llamadas",
          totalDuration: "Duración Total",
        },
        timeSaved: {
          title: "Tiempo Ahorrado",
          minutes: "Minutos",
          hours: "Horas",
          days: "Días",
        },
      },
      login: {
        recentSessions: "Sesiones de Acceso Recientes",
        currentSession: "Sesión Actual",
        loginNumber: "Acceso #{{number}}",
        noHistory: "No hay historial de acceso disponible",
        never: "Nunca",
        notAvailable: "No disponible",
        relativeTime: {
          justNow: "Justo ahora",
          minutesAgo: "hace {{count}}m",
          hoursAgo: "hace {{count}}h",
          daysAgo: "hace {{count}}d",
          weeksAgo: "hace {{count}}sem",
        },
      },
      subscription: {
        title: "Detalles de Suscripción",
        plan: "Plan",
        status: "Estado",
        paymentStatus: "Estado de Pago",
        amount: "Monto",
        startDate: "Fecha de Inicio",
        endDate: "Fecha de Fin",
        created: "Creado",
        lastUpdated: "Última Actualización",
        unknown: "Desconocido",
        features: {
          entUnlimited: "Consultas ilimitadas",
          entExpert: "Todas las funciones expertas",
          entCorporate: "Acceso a herramientas corporativas",
          entSupport: "Soporte enterprise prioritario",
          entIndefinite: "Acceso indefinido",
          expUnlimited: "Consultas ilimitadas",
          expAll: "Todas las funciones",
          expSupport: "Soporte prioritario",
          exBasic: "Funciones básicas",
          exLimited: "Consultas limitadas",
          exStandard: "Soporte estándar",
        },
        noSubscription: {
          title: "Sin suscripción",
          description: "Este usuario no tiene una suscripción activa.",
        },
      },
      actions: {
        editRole: "Editar Rol",
        editProfile: "Editar Perfil",
        editBio: "Editar Biografía",
        deactivate: "Desactivar",
        activate: "Activar",
        refresh: "Actualizar",
        deleteUser: "Eliminar Usuario",
        deactivateConfirm: "¿Desactivar a {{name}}? No será visible para los clientes.",
        activateConfirm: "¿Activar a {{name}}? Será visible para los clientes.",
        deleteError: "Error al eliminar usuario: {{error}}",
        toggleError: "Error: {{error}}",
      },
      status: {
        active: "Activo",
        inactive: "Inactivo",
        verified: "Verificado",
        pending: "Pendiente",
      },
    },
    pagination: {
      previous: "Anterior",
      next: "Siguiente",
    },
  },
  fr: {
    generateReport: "Générer Rapport IA",
    askCommunity: "Demander aux Experts",
    accessLibrary: "Accéder à la Bibliothèque",
    soapNoteSaved: "Enregistre ta consultation",
    analysisReady: "Analyse IA Prête",
    userManagement: {
      title: "Gestion des Utilisateurs",
      searchPlaceholder: "Rechercher par nom, email ou ID...",
      totalUsers: "Total des Utilisateurs",
      admins: "Administrateurs",
      specialists: "Spécialistes",
      clients: "Clients",
      enterprise: "Enterprise",
      filters: {
        all: "Tous",
        admin: "Administrateurs",
        specialist: "Spécialistes",
        client: "Clients",
        enterprise: "Enterprise",
      },
      sort: {
        label: "Trier par:",
        name: "Nom",
        email: "Email",
        role: "Rôle",
        loginCount: "Connexions",
        lastLogin: "Dernière Connexion",
        createdAt: "Créé le",
      },
      view: {
        grid: "Passer en vue liste",
        list: "Passer en vue grille",
      },
      refresh: "Actualiser",
      showing: "Affichage de {{count}} sur {{total}} utilisateurs",
      noUsers: {
        title: "Aucun utilisateur trouvé",
        description: "Essayez d'ajuster votre recherche ou vos filtres",
      },
      loading: "Chargement des utilisateurs...",
      error: "Échec du chargement des utilisateurs",
      tryAgain: "Réessayer",
      userCard: {
        verified: "Vérifié",
        pending: "En attente",
        lastLogin: "Dernière connexion",
        logins: "Connexions",
        view: "Voir",
        editRole: "Modifier le rôle",
        deleteUser: "Supprimer l'utilisateur",
        deleteConfirm: "Êtes-vous sûr de vouloir supprimer {{name}}? Cette action ne peut pas être annulée.",
      },
      roles: {
        admin: "Administrateur",
        specialist: "Spécialiste",
        client: "Client",
      },
      plans: {
        explorer: "Explorer",
        expert: "Expert",
        enterprise: "Enterprise",
      },
    },
    userDetail: {
      overview: "Aperçu",
      activityTab: "Activité",
      loginHistory: "Historique de Connexion",
      subscriptionTab: "Abonnement",
      quickStats: {
        totalLogins: "Total des Connexions",
        lastLogin: "Dernière Connexion",
        email: "Email",
        role: "Rôle",
      },
      profile: {
        title: "Informations du Profil",
        fullName: "Nom Complet",
        email: "Email",
        phone: "Téléphone",
        userId: "ID Utilisateur",
        accountCreated: "Compte Créé",
        lastUpdated: "Dernière Mise à Jour",
        specialty: "Spécialité",
        group: "Groupe",
        notProvided: "Non fourni",
        notSpecified: "Non spécifié",
        none: "Aucun",
      },
      extendedProfile: {
        title: "Profil Étendu",
        biography: "Biographie",
        yearsExp: "Années d'Expérience",
        languages: "Langues",
        education: "Éducation",
        years: "{{count}} ans",
      },
      activity: {
        noData: {
          title: "Aucune donnée d'activité",
          description: "Cet utilisateur n'a pas encore généré d'activité.",
        },
        aiChat: {
          title: "Chat IA",
          conversations: "Conversations",
          messages: "Messages",
          avgMessagesPerConv: "Moy Messages/Conv",
          characters: "Caractères",
        },
        soapvett: {
          title: "SOAPvett",
          recordings: "Enregistrements",
          sessions: "Sessions",
          avgDuration: "Durée Moy",
        },
        clinicFlow: {
          title: "ClinicFlow",
          totalAnalyses: "Total Analyses",
          normalMode: "Mode Normal",
          advancedMode: "Mode Avancé",
        },
        vettbox: {
          title: "VettBox",
          files: "Fichiers",
          totalSize: "Taille Totale",
          inGB: "En Go",
        },
        phoneCalls: {
          title: "Appels Téléphoniques",
          totalCalls: "Total des Appels",
          totalDuration: "Durée Totale",
        },
        timeSaved: {
          title: "Temps Économisé",
          minutes: "Minutes",
          hours: "Heures",
          days: "Jours",
        },
      },
      login: {
        recentSessions: "Sessions de Connexion Récentes",
        currentSession: "Session Actuelle",
        loginNumber: "Connexion #{{number}}",
        noHistory: "Aucun historique de connexion disponible",
        never: "Jamais",
        notAvailable: "Non disponible",
        relativeTime: {
          justNow: "À l'instant",
          minutesAgo: "il y a {{count}}min",
          hoursAgo: "il y a {{count}}h",
          daysAgo: "il y a {{count}}j",
          weeksAgo: "il y a {{count}}sem",
        },
      },
      subscription: {
        title: "Détails de l'Abonnement",
        plan: "Plan",
        status: "Statut",
        paymentStatus: "Statut de Paiement",
        amount: "Montant",
        startDate: "Date de Début",
        endDate: "Date de Fin",
        created: "Créé le",
        lastUpdated: "Dernière Mise à Jour",
        unknown: "Inconnu",
        features: {
          entUnlimited: "Consultations illimitées",
          entExpert: "Toutes les fonctionnalités expertes",
          entCorporate: "Accès aux outils corporatifs",
          entSupport: "Support enterprise prioritaire",
          entIndefinite: "Accès indéfini",
          expUnlimited: "Consultations illimitées",
          expAll: "Toutes les fonctionnalités",
          expSupport: "Support prioritaire",
          exBasic: "Fonctionnalités de base",
          exLimited: "Consultations limitées",
          exStandard: "Support standard",
        },
        noSubscription: {
          title: "Aucun abonnement",
          description: "Cet utilisateur n'a pas d'abonnement actif.",
        },
      },
      actions: {
        editRole: "Modifier le Rôle",
        editProfile: "Modifier le Profil",
        editBio: "Modifier la Biographie",
        deactivate: "Désactiver",
        activate: "Activer",
        refresh: "Actualiser",
        deleteUser: "Supprimer l'Utilisateur",
        deactivateConfirm: "Désactiver {{name}}? Il ne sera pas visible pour les clients.",
        activateConfirm: "Activer {{name}}? Il sera visible pour les clients.",
        deleteError: "Erreur lors de la suppression de l'utilisateur: {{error}}",
        toggleError: "Erreur: {{error}}",
      },
      status: {
        active: "Actif",
        inactive: "Inactif",
        verified: "Vérifié",
        pending: "En attente",
      },
    },
    pagination: {
      previous: "Précédent",
      next: "Suivant",
    },
  },
};
